const MEMBER_COMPUTED_FULL_QUERY = `
  personTrackingNumber
  indianStatus
  indianStatusReason
  nonEscMecStatus
  nonEscMecStatusReason
  ssnStatus
  ssnStatusReason
  citizenshipStatus
  citizenshipStatusReason
  citizenshipDataEventStatus
  citizenshipDataFoundIndicator
  qhpLawfulPresenceStatus
  qhpLawfulPresenceStatusReason
  fiveYearBarStatus
  fiveYearBarStatusReason
  medicaidLawfulPresenceStatus
  medicaidLawfulPresenceStatusReason
  under100FplWithLawfulPresenceDmiIndicator
  medicaidChipStandard {
    medicaidStandardPercent
    medicaidStandardBasisType
    chipStandardPercent
    chipStandardBasisType
    parentCaretakerChildList
    adultGroupCategoryStatus
    childCaretakerDeprivedStatus
    parentCaretakerCategoryStatus
  }
  medicaidNonMagiReferralStatus
  medicaidNonMagiReferralStatusReason
  preliminaryMedicaidStatus
  preliminaryMedicaidStatusReason
  preliminaryChipStatus
  preliminaryChipStatusReason
  preliminaryAptcStatus
  preliminaryAptcStatusReason
  preliminaryEmergencyMedicaidStatus
  preliminaryEmergencyMedicaidStatusReason
  dependentChildCoveredStatus
  dependentChildCoveredStatusReason
  chipStateHealthBenefitStatus
  chipStateHealthBenefitStatusReason
  chipWaitingPeriodStatus
  chipWaitingPeriodStatusReason
  escMecStatus
  escMecStatusReason
  incarcerationStatus
  incarcerationStatusReason
  income {
    irsDataStatus
    irsDataStatusReason
    medicaidIncomeStatus
    chipIncomeStatus
    medicaidChipIncomeStatusReason
    medicaidGapFillingIndicator
    annualIncomeExplanationRequired
    attestedMonthlyIndividualIncomeAmt
    attestedAnnualizedAptcIndividualIncomeAmt
    disregardAdjustAttestedMonthlyMedicaidHouseholdIncomePercent
    adjustAttestedMonthlyMedicaidHouseholdIncomeAmount
    adjustAttestedAnnualMedicaidHouseholdIncomeAmount
    employer {
      employer
      jobIncomeExplanationRequiredIndicator
      jobIncomeExplanationAcceptance
    }
  }
  medicaidResidencyStatus
  medicaidResidencyStatusReason
  emergencyMedicaidStatus
  emergencyMedicaidStatusReason
  qhpResidency {
    qhpResidencyStatus
    qhpResidencyStatusReason
    taxHouseholdResidencyAppliesIndicator
  }
  medicaidHouseholdComposition {
    medicaidHouseHoldStatus
    medicaidHouseHoldStatusReason
    medicaidTaxRoleType
    medicaidHouseholdSize
    medicaidHouseholdMemberIdentifiers
  }
  residencyAddress {
    residencyAddressSourceType
    streetName1
    streetName2
    cityName
    stateCode
    plus4Code
    zipCode
    countyName
    countyFipsCode
  }
  hraEvent {
    ichraResult {
      status
      statusReason
    }
  }
  qhpStatus
  qhpStatusReason
  aptcStatus
  aptcStatusReason
  secretaryHardshipExemptionIndicator
  csrStatus
  csrStatusReason
  csrVariant
  medicaidStatus
  medicaidStatusReason
  chipStatus
  chipStatusReason
  unbornChildChipStatus
  unbornChildChipStatusReason
  transferApplicantToStateStatus
  transferApplicantToStateStatusReason
  eligibleSEP {
    status
    statusReason
    startDate
    endDate
    type
    verificationSourceType
    coverage60DayBeforeCircumstanceChangeConfirmedIndicator
  }
  cicWithMedicaidChipPdmIndicator
`;

export default MEMBER_COMPUTED_FULL_QUERY;
